import Header from '../Header';
import React from 'react';
import Body from '../Body';
import DataProvider from '../DataProvider';

function App() {
  return (
    <DataProvider>
      <div className='wrapper'>
        <Header />
        <Body />
      </div>
    </DataProvider>
  );
}

export default App;